import { initOnce } from "./utils/init";
import App from "./App.svelte";
import Koronastripe from "./components/Koronastripe.svelte";
import Innlagte from "./components/integrations/Innlagte.svelte";
import Smitteinnlagte from "./components/integrations/Smitteinnlagte.svelte";

initOnce("#koronaoversikt", (app) => {
	new App({
		target: app,
	});
});

initOnce("#koronastripe-v2", (app) => {
	new Koronastripe({
		target: app,
	});
});

initOnce("#korona-innlagte-respirator", (app) => {
	new Innlagte({
		target: app,
	});
});

initOnce("#korona-innlagte", (app) => {
	new Innlagte({
		target: app,
		props: {
			viewRespirator: false,
		},
	});
});

initOnce("#korona-smitte-innlagte", (app) => {
	new Smitteinnlagte({
		target: app,
	});
});
